// extracted by mini-css-extract-plugin
export default {"why_section":"Why_why_section__j4plH","left":"Why_left__vLyax","right":"Why_right__ws56P","startedBtn":"Why_startedBtn__uqpOd"};